import React from 'react';
import { NavLink } from 'react-router-dom';
import MyPage from "../../../src/MyPage";
import SubTabsInputs from "../../../src/SubTabsInputs";
import '../../App.css';
import '../../styles.css';

function Inputs() {
  return (
    <div className="scrollable-container">
      <MyPage />
      <SubTabsInputs />
    </div>
  );
}

export default Inputs;
